<template>
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.53516" y="12.021" width="12" height="2" transform="rotate(-45 3.53516 12.021)" fill="#4C7799" />
    <rect x="12.0215" y="13.4351" width="12" height="2" transform="rotate(-135 12.0215 13.4351)" fill="#4C7799" />
  </svg>
</template>
